var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fl-check" },
    [
      _c("div", { staticClass: "container" }, [
        _c("p", { staticStyle: { margin: "20px 0" } }, [
          _c(
            "b",
            {
              staticStyle: {
                cursor: "pointer",
                "font-size": "16px",
                "border-bottom": "2px dashed #333",
                "font-weight": "500",
              },
              on: {
                click: function ($event) {
                  _vm.showDescr = !_vm.showDescr
                },
              },
            },
            [_vm._v("Описание")]
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "uk-icon-question-circle",
            staticStyle: {
              "vertical-align": "top",
              "font-size": "0.8rem",
              "padding-left": "2px",
            },
          }),
        ]),
        _vm._v(" "),
        _vm.showDescr
          ? _c(
              "p",
              {
                staticStyle: {
                  "font-size": "16px",
                  "font-weight": "400",
                  margin: "20px 0",
                  "max-width": "960px",
                  padding: "20px",
                  background: "#eee",
                  border: "1px solid lightgray",
                  "border-radius": "5px",
                },
              },
              [
                _c("b", [
                  _vm._v(
                    "Среднее время проверки составляет от 0.5 до 3 минут."
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n            Сформированный отчёт будет загружен в виде файла в вашем браузере.\n            "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  "\n            Позволяет осуществить проверку даже если имеются не все необходимые исходные данные по проверяемому ФЛ. Например, когда имеются только ФИО и дата рождения или только ИНН ФЛ.\n            "
                ),
                _c("br"),
                _vm._v(
                  "\n            Позволяет найти в процессе поиска по дополнительным ресурсам, в случае наличия информации в них, расширенные установочные данные, такие как:\n            "
                ),
                _vm._m(0),
                _vm._v(
                  "\n            Позволяет оперативно обнаружить негативные факторы в отношении ФЛ (вхождение в «черные списки», банкротство, большие суммы налоговых задолженностей или исполнительных производств и прочие), а также другую важную информацию на стадии до начала сотрудничества, а также дать основания для прекращения текущего сотрудничества, если в процессе будут выявлены новые появившиеся негативные факторы.\n            "
                ),
                _c("br"),
                _vm._v(
                  "\n            Позволяет выявить возможность сотрудничества с ФЛ в качестве ИП или самозанятого и использовать выгоды соответствующих режимов налогообложения.\n            "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Типовые примеры использования:")]),
                _vm._v(" "),
                _vm._m(1),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "fl-check__box" }, [
          _c("ul", { staticClass: "fl-check__list" }, [
            _c("h3", { staticClass: "fl-check__list__subheader" }, [
              _vm._v("Проверяемые реестры:"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [_vm._v("Проверка паспорта")]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [_vm._v("Проверка ИНН")]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр федерального розыска МВД РФ"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр террористов/экстремистов"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр розыска ФСИН"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Привлечение к уголовной ответственности"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр розыска ФССП (совершенные преступления)"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр розыска ФССП (по исполнительным производствам)"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Банк данных исполнительных производств ФССП"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр банкротств физических лиц"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр лиц, уволенных в связи с утратой доверия"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Налоговая задолженность ФЛ"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр залогов движимого имущества"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр дисквалифицированных лиц ФНС РОССИИ"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр ограничений участия в ЮЛ ФНС РОССИИ"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [_vm._v("Наличие статуса ИП")]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Наличие статуса самозанятого"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр массовых руководителей"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Реестр массовых учредителей"),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.getClass() }, [
              _vm._v("Аффилированные структуры"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form" }, [
            _c("div", { staticClass: "form__container" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formRadio,
                    expression: "formRadio",
                  },
                ],
                staticClass: "form__radio",
                attrs: { value: "nameForm", type: "radio", name: "formRadio" },
                domProps: { checked: _vm._q(_vm.formRadio, "nameForm") },
                on: {
                  change: function ($event) {
                    _vm.formRadio = "nameForm"
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__box" }, [
                _vm._m(2),
                _vm._v(" "),
                (_vm.formRadio == "nameForm" ? "text" : "password") ===
                "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.surname,
                          expression: "surname",
                        },
                      ],
                      staticClass: "surname",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "Фамилия",
                        disabled: _vm.formRadio == "innForm",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.surname)
                          ? _vm._i(_vm.surname, null) > -1
                          : _vm.surname,
                      },
                      on: {
                        input: function ($event) {
                          _vm.surname = _vm.surname.replace(/[^а-яa-z-]/gi, "")
                        },
                        change: function ($event) {
                          var $$a = _vm.surname,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.surname = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.surname = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.surname = $$c
                          }
                        },
                      },
                    })
                  : (_vm.formRadio == "nameForm" ? "text" : "password") ===
                    "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.surname,
                          expression: "surname",
                        },
                      ],
                      staticClass: "surname",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "Фамилия",
                        disabled: _vm.formRadio == "innForm",
                        type: "radio",
                      },
                      domProps: { checked: _vm._q(_vm.surname, null) },
                      on: {
                        input: function ($event) {
                          _vm.surname = _vm.surname.replace(/[^а-яa-z-]/gi, "")
                        },
                        change: function ($event) {
                          _vm.surname = null
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.surname,
                          expression: "surname",
                        },
                      ],
                      staticClass: "surname",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "Фамилия",
                        disabled: _vm.formRadio == "innForm",
                        type: _vm.formRadio == "nameForm" ? "text" : "password",
                      },
                      domProps: { value: _vm.surname },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.surname = $event.target.value
                          },
                          function ($event) {
                            _vm.surname = _vm.surname.replace(
                              /[^а-яa-z-]/gi,
                              ""
                            )
                          },
                        ],
                      },
                    }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__box" }, [
                _vm._m(3),
                _vm._v(" "),
                (_vm.formRadio == "nameForm" ? "text" : "password") ===
                "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name",
                        },
                      ],
                      staticClass: "name",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "Имя",
                        disabled: _vm.formRadio == "innForm",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.name)
                          ? _vm._i(_vm.name, null) > -1
                          : _vm.name,
                      },
                      on: {
                        input: function ($event) {
                          _vm.name = _vm.name.replace(/[^а-яa-z-]/gi, "")
                        },
                        change: function ($event) {
                          var $$a = _vm.name,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.name = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.name = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.name = $$c
                          }
                        },
                      },
                    })
                  : (_vm.formRadio == "nameForm" ? "text" : "password") ===
                    "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name",
                        },
                      ],
                      staticClass: "name",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "Имя",
                        disabled: _vm.formRadio == "innForm",
                        type: "radio",
                      },
                      domProps: { checked: _vm._q(_vm.name, null) },
                      on: {
                        input: function ($event) {
                          _vm.name = _vm.name.replace(/[^а-яa-z-]/gi, "")
                        },
                        change: function ($event) {
                          _vm.name = null
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.name,
                          expression: "name",
                        },
                      ],
                      staticClass: "name",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "Имя",
                        disabled: _vm.formRadio == "innForm",
                        type: _vm.formRadio == "nameForm" ? "text" : "password",
                      },
                      domProps: { value: _vm.name },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          },
                          function ($event) {
                            _vm.name = _vm.name.replace(/[^а-яa-z-]/gi, "")
                          },
                        ],
                      },
                    }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__box" }, [
                _vm._m(4),
                _vm._v(" "),
                (_vm.formRadio == "nameForm" ? "text" : "password") ===
                "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.patronymic,
                          expression: "patronymic",
                        },
                      ],
                      staticClass: "patronymic",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "Отчество",
                        disabled: _vm.formRadio == "innForm",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.patronymic)
                          ? _vm._i(_vm.patronymic, null) > -1
                          : _vm.patronymic,
                      },
                      on: {
                        input: function ($event) {
                          _vm.patronymic = _vm.patronymic.replace(
                            /[^а-яa-z-]/gi,
                            ""
                          )
                        },
                        change: function ($event) {
                          var $$a = _vm.patronymic,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.patronymic = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.patronymic = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.patronymic = $$c
                          }
                        },
                      },
                    })
                  : (_vm.formRadio == "nameForm" ? "text" : "password") ===
                    "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.patronymic,
                          expression: "patronymic",
                        },
                      ],
                      staticClass: "patronymic",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "Отчество",
                        disabled: _vm.formRadio == "innForm",
                        type: "radio",
                      },
                      domProps: { checked: _vm._q(_vm.patronymic, null) },
                      on: {
                        input: function ($event) {
                          _vm.patronymic = _vm.patronymic.replace(
                            /[^а-яa-z-]/gi,
                            ""
                          )
                        },
                        change: function ($event) {
                          _vm.patronymic = null
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.patronymic,
                          expression: "patronymic",
                        },
                      ],
                      staticClass: "patronymic",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "Отчество",
                        disabled: _vm.formRadio == "innForm",
                        type: _vm.formRadio == "nameForm" ? "text" : "password",
                      },
                      domProps: { value: _vm.patronymic },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.patronymic = $event.target.value
                          },
                          function ($event) {
                            _vm.patronymic = _vm.patronymic.replace(
                              /[^а-яa-z-]/gi,
                              ""
                            )
                          },
                        ],
                      },
                    }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form__box" }, [
                _vm._m(5),
                _vm._v(" "),
                (_vm.formRadio == "nameForm" ? "text" : "password") ===
                "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.birthday,
                          expression: "birthday",
                        },
                      ],
                      staticClass: "birthday",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "31.12.2020",
                        maxlength: "10",
                        disabled: _vm.formRadio == "innForm",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.birthday)
                          ? _vm._i(_vm.birthday, null) > -1
                          : _vm.birthday,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.dateFormat($event)
                        },
                        change: function ($event) {
                          var $$a = _vm.birthday,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.birthday = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.birthday = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.birthday = $$c
                          }
                        },
                      },
                    })
                  : (_vm.formRadio == "nameForm" ? "text" : "password") ===
                    "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.birthday,
                          expression: "birthday",
                        },
                      ],
                      staticClass: "birthday",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "31.12.2020",
                        maxlength: "10",
                        disabled: _vm.formRadio == "innForm",
                        type: "radio",
                      },
                      domProps: { checked: _vm._q(_vm.birthday, null) },
                      on: {
                        input: function ($event) {
                          return _vm.dateFormat($event)
                        },
                        change: function ($event) {
                          _vm.birthday = null
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.birthday,
                          expression: "birthday",
                        },
                      ],
                      staticClass: "birthday",
                      class: { paled: _vm.formRadio == "innForm" },
                      attrs: {
                        placeholder: "31.12.2020",
                        maxlength: "10",
                        disabled: _vm.formRadio == "innForm",
                        type: _vm.formRadio == "nameForm" ? "text" : "password",
                      },
                      domProps: { value: _vm.birthday },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.birthday = $event.target.value
                          },
                          function ($event) {
                            return _vm.dateFormat($event)
                          },
                        ],
                      },
                    }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__container inn-form" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formRadio,
                    expression: "formRadio",
                  },
                ],
                staticClass: "form__radio",
                attrs: { type: "radio", value: "innForm", name: "formRadio" },
                domProps: { checked: _vm._q(_vm.formRadio, "innForm") },
                on: {
                  change: function ($event) {
                    _vm.formRadio = "innForm"
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "form__box" }, [
                _vm._m(6),
                _vm._v(" "),
                (_vm.formRadio == "innForm" ? "text" : "password") ===
                "checkbox"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inn,
                          expression: "inn",
                        },
                      ],
                      staticClass: "inn",
                      class: { paled: _vm.formRadio == "nameForm" },
                      attrs: {
                        placeholder: "ИНН ФЛ",
                        maxlength: 12,
                        disabled: _vm.formRadio == "nameForm",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.inn)
                          ? _vm._i(_vm.inn, null) > -1
                          : _vm.inn,
                      },
                      on: {
                        input: function ($event) {
                          _vm.inn = _vm.inn.replace(/[^0-9]/g, "")
                        },
                        change: function ($event) {
                          var $$a = _vm.inn,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.inn = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.inn = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.inn = $$c
                          }
                        },
                      },
                    })
                  : (_vm.formRadio == "innForm" ? "text" : "password") ===
                    "radio"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inn,
                          expression: "inn",
                        },
                      ],
                      staticClass: "inn",
                      class: { paled: _vm.formRadio == "nameForm" },
                      attrs: {
                        placeholder: "ИНН ФЛ",
                        maxlength: 12,
                        disabled: _vm.formRadio == "nameForm",
                        type: "radio",
                      },
                      domProps: { checked: _vm._q(_vm.inn, null) },
                      on: {
                        input: function ($event) {
                          _vm.inn = _vm.inn.replace(/[^0-9]/g, "")
                        },
                        change: function ($event) {
                          _vm.inn = null
                        },
                      },
                    })
                  : _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.inn,
                          expression: "inn",
                        },
                      ],
                      staticClass: "inn",
                      class: { paled: _vm.formRadio == "nameForm" },
                      attrs: {
                        placeholder: "ИНН ФЛ",
                        maxlength: 12,
                        disabled: _vm.formRadio == "nameForm",
                        type: _vm.formRadio == "innForm" ? "text" : "password",
                      },
                      domProps: { value: _vm.inn },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.inn = $event.target.value
                          },
                          function ($event) {
                            _vm.inn = _vm.inn.replace(/[^0-9]/g, "")
                          },
                        ],
                      },
                    }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form__container label-room",
                staticStyle: { margin: "20px 20px 0 0" },
              },
              [
                _c("label", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hasApproval,
                        expression: "hasApproval",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.hasApproval)
                        ? _vm._i(_vm.hasApproval, null) > -1
                        : _vm.hasApproval,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.hasApproval,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.hasApproval = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.hasApproval = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.hasApproval = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "Настоящим подтверждаю наличие письменного или иным образом зафиксированного согласия\n                        физического лица на обработку его персональных данных."
                    ),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form__container",
                staticStyle: {
                  "justify-content": "flex-end",
                  "margin-top": "20px",
                  gap: "5px",
                },
              },
              [
                _c(
                  "button",
                  { staticClass: "btn", on: { click: _vm.clearForm } },
                  [_vm._v("Очистить")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn blue",
                    class: { inactive: _vm.getInapproval() },
                    attrs: { disabled: _vm.getInapproval() },
                    on: { click: _vm.addData },
                  },
                  [_vm._v("Поиск")]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.limits
              ? _c(
                  "p",
                  {
                    staticStyle: { "font-size": "14px", "text-align": "right" },
                  },
                  [
                    _vm._v(
                      "Использовано запросов: " + _vm._s(_vm.limits.used_total)
                    ),
                    _vm.limits.total
                      ? _c("span", [_vm._v(" из " + _vm._s(_vm.limits.total))])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._m(7),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.status == 0 || _vm.status == 3 || _vm.loading
        ? _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c(
                "span",
                { staticStyle: { color: "#444", "font-size": "12px" } },
                [
                  _vm._v(
                    "Данные подготавливаются. Приблизительное время ожидания не более 5 минут."
                  ),
                ]
              ),
              _vm._v(" "),
              _c("shestirenka"),
            ],
            1
          )
        : _vm.status == 2
        ? _c("div", { staticStyle: { "text-align": "center" } }, [
            _c(
              "span",
              { staticStyle: { color: "#444", "font-size": "12px" } },
              [_vm._v("По данному запросу данных не найдено.")]
            ),
          ])
        : _vm.status == -1 && _vm.status == -2 && _vm.status == -3
        ? _c("div", { staticStyle: { "text-align": "center" } }, [
            _c(
              "span",
              { staticStyle: { color: "#444", "font-size": "12px" } },
              [_vm._v("При запросе произошла ошибка. Повторите запрос.")]
            ),
          ])
        : _vm.status == 4
        ? _c("div", { staticStyle: { "text-align": "center" } }, [
            _c(
              "span",
              { staticStyle: { color: "#444", "font-size": "12px" } },
              [_vm._v("Ошибка. Превышен лимит ожидания.")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("history", { ref: "history" }),
      _vm._v(" "),
      _vm.upload
        ? _c("flCheckPdf", {
            attrs: {
              upload: _vm.upload,
              dateCheck: _vm.dateCheck,
              name: _vm.name ? _vm.name : "",
              surname: _vm.surname ? _vm.surname : "",
              patronymic: _vm.patronymic ? _vm.patronymic : "",
              birthday: _vm.birthday ? _vm.birthday : "",
              inn: _vm.inn ? _vm.inn : "",
              list: _vm.list,
              formRadio: _vm.formRadio,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      {
        staticStyle: {
          "list-style-type": "disc",
          "padding-left": "25px !important",
        },
      },
      [
        _c("li", [_vm._v("выдававшиеся паспорта")]),
        _vm._v(" "),
        _c("li", [_vm._v("ИНН ФЛ")]),
        _vm._v(" "),
        _c("li", [_vm._v("номера телефонов, включая мобильные")]),
        _vm._v(" "),
        _c("li", [_vm._v("связанные государственные номера автомобилей")]),
        _vm._v(" "),
        _c("li", [_vm._v("связанные адреса.")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      {
        staticStyle: {
          "list-style-type": "disc",
          "padding-left": "25px !important",
          "max-width": "100%",
        },
      },
      [
        _c("li", [_vm._v("проверка потенциальных контрагентов-ФЛ")]),
        _vm._v(" "),
        _c("li", [_vm._v("проверка кандидатов на работу")]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "периодическая проверка отдельных контрагентов-ФЛ (например, раз в месяц/квартал/год)"
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "периодическая проверка сотрудников (например, раз в месяц/квартал/год)"
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form__header" }, [
      _vm._v("Фамилия"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form__header" }, [
      _vm._v("Имя"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form__header" }, [
      _vm._v("Отчество"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form__header" }, [
      _vm._v("Дата рождения"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form__header" }, [
      _vm._v("ИНН ФЛ"),
      _c("span", [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "text-align": "end" } }, [
      _c("span", { attrs: { id: "asterics" } }, [_vm._v("*")]),
      _vm._v(" - поля обязательные к заполнению"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }